export enum TipoPrestacaoDeContas {
  parcial = "Parcial",
  final = "Final",
}
